import React from "react";
import PageTitle from "../../Layout/PageTitle";
import Header from "./../../Layout/Header1";
import bnr from "./../../../images/banner/bnr3.jpg";
import Footer5 from "./../../Layout/footer5";
import MathsTable from "./MathsTable";

function Maths() {
  return (
    <>
      <Header />
      <div
        className="dlab-bnr-inr overlay-primary bg-pt"
        style={{ backgroundImage: "url(" + bnr + ")" }}
      >
        <PageTitle motherMenu="Mathematics" activeMenu="Books" />
      </div>
      <div className="container">
        <MathsTable />
      </div>
      <Footer5 />
    </>
  );
}

export default Maths;
